<template>
  <div class="person" v-loading="loading" element-loading-text="数据加载中...">
    <div class="search">
      <span class="title">人员管理</span>
      <div class="flex">
        <div class="condition">
          <span style="flex: 1">区域：</span>
          <el-select v-model="selectFrom.areaId" @change="getList" filterable placeholder="请选择区域">
            <el-option v-for="item in AreaData1" :key="item.areaId" :label="item.areaName" :value="item.areaId"></el-option>
          </el-select>
        </div>
        <div class="condition">
          <span style="flex: 1">用户：</span>
          <el-input v-model="selectFrom.userName" @change="getList" placeholder="请输入用户" style="width: 250px"></el-input>
        </div>
        <el-button type="success" @click="clickAdd" v-if="$store.state.user.isPatrols">新增</el-button>
      </div>
    </div>
    <div class="table">
      <el-table :data="tableData" height="100%" align="center" :header-cell-style="{ background: '#f4f7fe' }">
        <el-table-column prop="userName" label="用户"></el-table-column>
        <el-table-column prop="areaNmae" label="区域"></el-table-column>
        <el-table-column prop="level" label="级别">
          <template slot-scope="scope">
            {{ scope.row.level == 1 ? '巡护' : '管理' }}
          </template>
        </el-table-column>
        <el-table-column prop="creationTime" label="创建时间"></el-table-column>
        <el-table-column label="操作" align="right">
          <template slot-scope="scope">
            <el-button @click="clickEdit(scope.row)" type="success" size="small" v-if="$store.state.user.isPatrols">编辑</el-button>
            <el-button @click="deletePeople(scope.row)" type="success" size="small" v-if="$store.state.user.isPatrols">删除</el-button>
            <el-button @click="clickDetails(scope.row)" type="success" size="small">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50]"
        layout="sizes, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 新增 编辑弹窗 -->
    <el-dialog :title="title" :visible.sync="dialogVisible" width="400px" :before-close="handleClose">
      <el-form :model="peopleFrom" label-width="60px">
        <el-form-item label="区域">
          <el-select v-model="peopleFrom.areaId" placeholder="请选择区域" filterable style="width: 100%" :disabled="dialogType == 'details'">
            <el-option v-for="item in AreaData2" :key="item.areaId" :label="item.areaName" :value="item.areaId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户">
          <el-cascader
            ref="cascaderAddr"
            v-model="peopleFrom.selectUserCode"
            :options="peopeleData2"
            placeholder="请选择用户"
            :show-all-levels="false"
            style="width: 100%"
            filterable="true"
            v-if="title == '新增乡镇管理'"
          ></el-cascader>
          <div v-else>{{ peopleFrom.userName }}</div>
        </el-form-item>
        <el-form-item label="级别">
          <el-radio v-model="peopleFrom.level" :label="1" :disabled="dialogType == 'details'">巡护</el-radio>
          <el-radio v-model="peopleFrom.level" :label="2" :disabled="dialogType == 'details'">管理</el-radio>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="success" v-if="title == '新增乡镇管理'" @click="addPeople">确 定</el-button>
        <el-button type="success" v-if="title !== '新增乡镇管理'" @click="editPeople">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { GetAreaBox, GetPatrolUserByArea, GetPatrolsUserLis, AddPatrolsUser, GetPatrolsUserDealLis, UpdatePatrolsUser, DeletePatrolsUser } from '@/api/Patrol'
  import { GetDepartmentUser } from '@/api/staff.js'
  export default {
    name: 'outing',
    data() {
      return {
        title: '新增乡镇管理',
        // 新增 编辑 表单
        peopleFrom: {
          areaId: 0,
          selectUserCode: '',
          userCode: '',
          level: 1,
        },
        // 弹窗展示状态
        dialogVisible: false,
        // 区域数据
        AreaData1: [],
        AreaData2: [],
        // 用户数据
        peopeleData1: [{ userCode: '-1', userName: '全部' }],
        peopeleData2: [],
        // 查询表单
        selectFrom: {
          areaId: -1,
          userName: '',
        },
        tableData: [], // 表格数据
        // 弹窗类型
        dialogType: 'add',
        detailModal: false, //详情
        key: null, // 搜索关键字
        loading: false, // 数据是否处于加载状态
        detailForm: {}, //详情数据
        total: 0, // 数据总数
        currentPage: 1, // 当前页数
        pageSize: 10, // 当前查询数据个数
        isDialogVisible: false,
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      },
    },
    mounted() {
      this.getArea(1)
      this.getList()
    },
    methods: {
      // 分页查询
      handleSizeChange(e) {
        this.pageSize = e
        this.getList()
      },
      handleCurrentChange(e) {
        this.currentPage = e
        this.getList()
      },
      // 获取区域数据
      getArea(type) {
        GetAreaBox(type).then((res) => {
          if (res.data.state == 1) {
            if (type == 1) {
              this.AreaData1 = res.data.data
            } else if (type == 2) {
              this.AreaData2 = res.data.data
            }
          }
        })
      },
      // 区域数据更改
      changeArea(areaId) {
        this.selectFrom.userName = '-1'
        this.peopeleData1 = []
        this.getList()
        GetPatrolUserByArea(areaId).then((res) => {
          if (res.data.state == 1) {
            this.peopeleData1 = res.data.data
          }
        })
      },
      // 获取列表数据
      getList() {
        this.selectFrom.pageNumber = this.currentPage
        this.selectFrom.pageSize = this.pageSize
        GetPatrolsUserLis(this.selectFrom).then((res) => {
          if (res.data.state == 1) {
            this.tableData = res.data.data.lis
            this.total = res.data.data.count
          }
        })
      },
      // 点击新增按钮
      clickAdd() {
        this.getArea(2)
        this.dialogVisible = true
        this.dialogType = 'add'
        GetDepartmentUser().then((res) => {
          this.peopeleData2 = res.data.data
        })
        this.title = '新增乡镇管理'
      },
      // 新增用户
      addPeople() {
        if (this.peopleFrom.selectUserCode == '') {
          return this.$message.warning('请选择用户')
        }
        this.peopleFrom.userCode = this.peopleFrom.selectUserCode[this.peopleFrom.selectUserCode.length - 1]
        AddPatrolsUser(this.peopleFrom).then((res) => {
          if (res.data.state == 1) {
            this.$message.success('新增成功')
            this.getList()
            this.handleClose()
          }
        })
      },
      // 关闭弹窗
      handleClose() {
        this.peopleFrom = {
          areaId: 0,
          selectUserCode: '',
          userCode: '',
          level: 1,
        }
        this.dialogVisible = false
      },
      // 点击编辑按钮
      clickEdit(row) {
        this.title = row.userName
        this.getArea(2)
        this.dialogType = 'edit'
        GetPatrolsUserDealLis(row.id).then((res) => {
          if (res.data.state == 1) {
            this.peopleFrom = res.data.data
            this.dialogVisible = true
          }
        })
      },
      // 编辑保存
      editPeople() {
        UpdatePatrolsUser(this.peopleFrom).then((res) => {
          if (res.data.state == 1) {
            this.$message.success('修改成功')
            this.getList()
            this.handleClose()
          }
        })
      },
      // 删除用户
      deletePeople(row) {
        this.$confirm('是否删除该用户?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          DeletePatrolsUser(row.id).then((res) => {
            if (res.data.state == 1) {
              this.$message.success('删除成功')
              this.getList()
            }
          })
        })
      },
      // 查看详情
      clickDetails(row) {
        this.title = row.userName
        this.getArea(2)
        this.dialogType = 'details'
        GetPatrolsUserDealLis(row.id).then((res) => {
          if (res.data.state == 1) {
            this.peopleFrom = res.data.data
            this.dialogVisible = true
          }
        })
      },
    },
  }
</script>
<style lang="less" scoped>
  .person {
    height: 100%;
    .search {
      display: flex;
      justify-content: space-between;
      padding: 15px;
      .title {
        font-size: 20px;
        font-weight: bold;
      }
      .condition {
        display: flex;
        align-items: center;
        margin-right: 20px;
      }
      .el-input {
        margin-right: 30px;
        width: 500px;
      }
    }
    .table {
      padding: 0px 15px;
      height: calc(100vh - 250px);
    }
    .page {
      text-align: center;
    }
    /deep/ .el-dialog__header {
      padding: 10px;
      background-color: #5bacf0;
    }
    /deep/ .el-dialog__title {
      color: #fff;
    }
    /deep/ .el-dialog__body {
      padding: 15px;
    }
    /deep/ .el-dialog__footer {
      padding: 0px 10px 10px 10px;
    }
    /deep/ .el-drawer {
      top: 60px !important;
      height: 100% !important;
    }
    /deep/ .el-dialog__title {
      color: #fff;
    }

    /deep/ .el-dialog__close {
      color: #fff;
    }
    /deep/ .el-dialog__headerbtn {
      top: 15px;
    }
  }
</style>
